// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Loading_loadingContainer__4HrfJ","loadingText":"Loading_loadingText__1C1CR"};